<template>
  <div class="d-flex flex-column justify-content-center">
    <div v-if="!hidepage" class="wet-section">
      <div class="container">
        <div class="wet-section-title text-center">
          <h1 class="empty-ph">
            {{strings.login && strings.login.welcome}}
          </h1>
        </div>
        <div class="row justify-content-center">
          <div class="col-12 col-sm-8 col-lg-5">
            <form @submit.prevent="submit">
              <div
                class="wet-input wet-input-with-label"
                :class="v$.form.email.$error ? 'wet-input-error' : ''"
              >
                <input
                  id="wet-input-email"
                  type="text"
                  :placeholder="strings.login && strings.login.email"
                  v-model.lazy.trim="v$.form.email.$model"
                >
                <label for="wet-input-email">
                  {{ strings.login && strings.login.email }}
                </label>
              </div>
              <div
                class="wet-input wet-input-with-label"
                :class="v$.form.password.$error ? 'wet-input-error' : ''"
              >
                <input
                  id="wet-input-password"
                  type="password"
                  :placeholder="strings.login && strings.login.password"
                  v-model.trim="v$.form.password.$model"
                >
                <label for="wet-input-password">
                  {{ strings.login && strings.login.password }}
                </label>
              </div>
              <div
                v-if="v$.form.email.$error"
                class="small text-primary mt-n2 mb-3 mx-3"
              >
                {{ this.strings.login && this.strings.login.error_login }}
              </div>
              <div
                v-if="v$.form.password.$error"
                class="small text-primary mt-n2 mb-3 mx-3"
              >
                {{ this.strings.login && this.strings.login.error_login }}
              </div>
              <div class="d-flex">
                <button
                  id="back-button"
                  type="button"
                  class="wet-button wet-button-flat empty-ph"
                  style="min-width:4rem;"
                  @click.prevent="back"
                >{{strings.commonApp && strings.commonApp.back_text}}</button>
                <button
                  id="login-button"
                  type="submit"
                  class="wet-button empty-ph ms-3 flex-fill"
                  :disabled="disabled"
                >{{strings.login && strings.login.button_login}}</button>
              </div>
            </form>
            <div class="text-center text-secondary my-4">
              <router-link
                :to="{ name: 'forgot', params: { ...$route.params } }"
                id="login-remember-link"
              >{{ strings.login && strings.login.forget }}</router-link>
            </div>
            <div
              v-if="[`${insurancePageName}`, 'settings']
              .includes($route.query && $route.query.redirect)"
              class="alert alert-primary my-3"
            >
              {{ strings.login && strings.login.error_login_first }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, reactive, ref, watch, onMounted } from 'vue';
import { required, email } from 'vuelidate/lib/validators';
import useVuelidate from '@vuelidate/core'; // Vuelidate-Integration für Composition API
import common from '@/mixins/common';
import LogService from '@/services/LogService';
import configEnv from '@/enums/configEnv';
import store from '@/store';
import router from '@/router';
import { useCommon } from '@/composables/common';
import wpSection from '@/enums/wpSection';


export default {
  mixins: [common],
  setup() {
    // Store und Routerzugriff
    const route = router.currentRoute;

    // Reaktive Zustände
    const loginApi = '/api/user/login';
    const userStatusApi = '/api/user/status/';
    const magicOrderApi = '/api/user/magic/order';
    const magicLoginApi = '/api/user/magic/login';
    const availableUrlRedirect = ['done', 'additional', 'buy', 'password-reset'];

    const form = reactive({
      email: '',
      password: '',
    });

    const loading = ref([]);
    const pwdErr = ref(false);
    const hidepage = ref(true);

    const disabled = computed(() => {
      return v$.value.$invalid || Object.values(form).some((el) => !el) || loading.value.length > 0;
    });

    // Validierung mit Vuelidate
    const rules = {
      form: {
        email: { required, email },
        password: {
          required,
          pwdErr: () => !pwdErr.value,
        },
      },
    };
    const v$ = useVuelidate(rules, { form });

    // Werte aus Vuex
    const strings = computed(() => store.state.strings);

    const { getWordPressStrings, callApi } = useCommon();

    const checkMagicLink = async () => {
      const { magic_link, order_id } = route.query;
      LogService.log('query', route.query);
      let to = false;

      if (magic_link) {
        LogService.log(JSON.stringify(route.query, null, 2));
        const url = order_id ? `${magicOrderApi}/${order_id}` : magicLoginApi;
        const headers = { 'Magic-Code': magic_link };

        try {
          const res = await callApi({ url, headers });
          const hasUrlRedirect =
            route.query.redirect && availableUrlRedirect.includes(route.query.redirect);

          let name = hasUrlRedirect ? route.query.redirect : res.data.redirect;
          if (name === 'insurance-id') {
            name = `${configEnv.insurance_page_name}-id`;
          }

          const id = res.data.params?.id;
          if (name && id && !hasUrlRedirect) {
            to = { name, params: { ...route.params, id } };
          } else if (name) {
            to = { name, params: { ...route.params, id } };
            if (res.data.query) {
              to.query = res.data.query;
            }
          }
          LogService.log('to', to);
        } catch (error) {
          if (['404', '400'].includes(error.response?.status.toString())) {
            const message = strings.value?.login?.error_magic_nofound;
            const modal = {
              id: 'wet-login-magic-modal',
              content: `<div class="text-center">${message}</div>`,
              actions: [
                {
                  name: 'wet-login-magic-ok',
                  title: strings.value.commonApp?.ok,
                  event: 'close',
                },
              ],
            };
            store.dispatch('addModal', modal);
          } else LogService.log(error);
        }
      }

      return to;
    };

    const submit = async () => {
      LogService.log('start submit');
      v$.value.$touch();
      LogService.log('here1');
      if (v$.value.$invalid) return;
      LogService.log('here2');
      pwdErr.value = false;
      LogService.log('here3');
      const data = { ...form };
      LogService.log('here4');
      if (route.query.order_id) data.order_id = route.query.order_id;
      LogService.log('here5');
      try {
        LogService.log('here6');
        const res = await callApi({ url: loginApi, method: 'post', data });
        LogService.log('api-call', JSON.stringify(res));
        if (route.query.redirect || res.data.redirect) {
          router.push({
            name: route.query.redirect || res.data.redirect,
            params: { ...route.params, ...res.data.params },
          });
        } else {
          router.push({
            name: configEnv.login_success_redirect_page,
            params: { ...route.params },
          });
        }
      } catch (error) {
        LogService.log(error);
        if (error.response.status === 401) {
          pwdErr.value = true;
        }
      }
    };

    const getUserStatus = async () => {
      return callApi(userStatusApi);
    };

    const back = () => {
      router.back();
    };

    onMounted(async () => {
      await getWordPressStrings([wpSection.LOGIN, wpSection.COMMON_APP], wpSection.LOGIN);
      const res = await checkMagicLink();
      if (res) {
        router.push(res);
      } else {
        try {
          const res2 = await getUserStatus();
          if (['0', '1'].includes(`${res2.data.user?.status}`)) {
            router.push({ name: 'settings', params: { ...route.params } });
            return;
          }
        } catch (error) {
          //
        }
        hidepage.value = false;
      }
    });

    watch(
      () => form.password,
      (val) => {
        pwdErr.value = val.length === 0;
      }
    );

    const insurancePageName = configEnv.insurance_page_name;

    // Rückgabe von Werten/Methoden aus `setup`
    return {
      form,
      v$,
      strings,
      disabled,
      submit,
      back,
      hidepage,
      insurancePageName,
    };
  },
};
</script>
<style lang="scss">
  .wet-separated-title {
    border-bottom: 1px solid var(--gray-light);
    color: var(--gray);
    width: 100%;
    position: relative;
    margin: 2.25rem 0;

    &>* {
      position: absolute;
      color: inherit;
      top: 50%;
      left: 50%;
      line-height: 1;
      background-color: white;
      padding: .25rem 2rem;
      transform: translate(-50%, -50%);
    }
  }
</style>
